import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { CssBaseline, StyledEngineProvider } from '@mui/material';
import { Sanctum } from 'react-sanctum';

import api from 'api/helpers/axios';
import {
  loadEnvironment,
  getEnvironment
} from 'config/environments/environment';
import App from './App';

async function bootstrap() {
  await loadEnvironment();
  const environment = getEnvironment();

  api.defaults.baseURL = environment.baseUrl;

  const sanctumConfig = {
    apiUrl: environment.baseUrl,
    csrfCookieRoute: 'sanctum/csrf-cookie',
    signInRoute: 'login',
    signOutRoute: 'logout',
    userObjectRoute: 'user'
  };

  ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <React.StrictMode>
      <BrowserRouter>
        <StyledEngineProvider injectFirst>
          <CssBaseline />
          <Sanctum config={sanctumConfig}>
            <App />
          </Sanctum>
        </StyledEngineProvider>
      </BrowserRouter>
    </React.StrictMode>
  );
}

bootstrap();
